import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../../assets/Error.svg';
import { Typography } from '../Typography';
import './SelectInput.css';

const computeSelectClassName = (selectClassName, error) => {
  const classes = [selectClassName];

  if (error) {
    classes.push('select-input--error');
  }

  return classes.join(' ');
};

export const SelectInput = forwardRef(({
  id,
  onChange,
  displayLabel,
  name,
  wrapperClassName,
  labelClassName,
  selectClassName,
  selectOptionClassName,
  placeholder,
  required,
  options,
  error,
}, ref) => {
  const unusedRef = useRef();
  const inputRef = ref || unusedRef;
  const computedSelectClassName = computeSelectClassName(selectClassName, error);
  const computedLabel = required ? `${displayLabel}*` : displayLabel;

  return (
    <div className={wrapperClassName}>
      <label
        htmlFor={name}
        className={labelClassName}
      >
        {computedLabel}
      </label>
      <div className="select-input-inner-wrapper">
        <select
          id={id}
          data-testid="testid-SelectInput"
          ref={inputRef}
          defaultValue=""
          required={required}
          name={name}
          className={computedSelectClassName}
          onChange={onChange}
        >
          <option
            className={selectOptionClassName}
            disabled
            value=""
          >
            {placeholder}
          </option>
          {options.map(({ value, label }) => (
            <option
              key={value}
              className={selectOptionClassName}
              value={value}
            >
              {label}
            </option>
          ))}
        </select>
        {error && (
          <div className="error-icon">
            <img alt="" src={ErrorIcon} />
          </div>
        )}
      </div>
      {error && (
        <div className="text-input-error-message">
          <Typography className="error-text">
            {error}
          </Typography>
        </div>
      )}
    </div>
  );
});

SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  displayLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  selectClassName: PropTypes.string,
  selectOptionClassName: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  error: PropTypes.string,
};

SelectInput.defaultProps = {
  onChange: () => { },
  wrapperClassName: 'select-input-wrapper',
  labelClassName: 'select-input-label',
  selectClassName: 'select-input',
  selectOptionClassName: 'select-option-input',
  placeholder: 'Select',
  required: false,
  error: '',
};
